<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">
                <div>
                    <div class="callout callout-info">
                        <div class="table-responsive text-center">
                            <table class="table table-sm table-striped table-bordered table-middle">
                                <thead>
                                    <tr>
                                        <th class="align-middle">Maximum Loanable Amount</th>
                                        <th class="align-middle">Grace Period</th>
                                        <th class="align-middle">Loan Term</th>
                                        <th class="align-middle">Repayment Start Date</th>
                                        <th class="align-middle">Payment Mode</th>
                                        <th class="align-middle">Financing Charges</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="align-middle">{{matrix.max}}</td>
                                        <td class="align-middle">{{matrix.period}}</td>
                                        <td class="align-middle">{{matrix.term}}</td>
                                        <td class="align-middle">{{matrix.start}}</td>
                                        <td class="align-middle">{{matrix.mode}}</td>
                                        <td class="align-middle nowrap">
                                            <ul style="list-style: none; margin-left:0px;padding-left:0px;">
                                                <li v-for="(i, index) in matrix.charges" :key="index">
                                                    {{i}}
                                                </li>
                                            </ul>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Well done, you may now provide your preferred loan amount</h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 alert alert-success2">
                                <p class="card-text text-justify pb-0 mb-0">Your maximum loanable amount is <strong>Php {{formLoan.max_loan | curr}}</strong></p>
                                <em class="card-text text-justify pb-0 mb-0"><strong>Note:</strong> Requested loan amount is subject to assessment and approval by SB Corporation.</em>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Loan Amount</label>
                                    <div class="input-group input-group-sm">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                                        </div>
                                        <input v-if="req_loan_amt" @blur="req_loan_amt=false, checkLoanAmount()" @paste.prevent @keypress="maxNum($event)" type="number" class="form-control" v-model="formLoan.req_loan_amt" :class="{'is-invalid': $parent.submitting && $v.formLoan.req_loan_amt.$error}">
                                        <input v-else @focus="req_loan_amt=true" type="text" class="form-control" :value="formLoan.req_loan_amt ? $options.filters.curr(formLoan.req_loan_amt) : null" :class="{'is-invalid': $parent.submitting && $v.formLoan.req_loan_amt.$error}">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Loan Term (in months) (inclusive of grace period)</label>
                                    <select class="form-control custom-select-sm" v-model="formLoan.req_loan_term" :class="{'is-invalid': $parent.submitting && $v.formLoan.req_loan_term.$error}">
                                        <option :value='null' disabled>- Select -</option>
                                        <option v-for="i in term" :value="i">{{i}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="formLoan.track==3 || formLoan.track==4">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Grace Period (in months)</label>
                                    <select class="form-control custom-select-sm" v-model="formLoan.grace_period" :class="{'is-invalid': $parent.submitting && $v.formLoan.grace_period.$error}">
                                        <option :value='null' disabled>- Select -</option>
                                        <option v-for="i in period" :value="i">{{i}}</option>
                                    </select>
                                </div>

                            </div>
                            <div class="col-md-6">
                                <div class="form-group" v-if="formLoan.track==4">
                                    <label v-if="formLoan.track==4">Service Fee</label>
                                    <div class="input-group input-group-sm">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">&#8369</span>
                                        </div>
                                        <input type="text" class="form-control" :value="service_fee ? $options.filters.curr(service_fee) : null" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                    </div>
                                </div>
                                <div class="form-group" v-if="formLoan.track==3">
                                    <label v-if="formLoan.track==3">Interest Rate per Annum</label>
                                    <input class="form-control" v-model="formLoan.service_fee" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                </div>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <!-- <label>Service Fee</label> -->
                                    <label>Interest Rate per Annum</label>
                                    <input class="form-control" v-model="formLoan.service_fee" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                            <button class="btn btn-primary float-right" @click="next">Next<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    </transition>
</template>
<script>
import moment from "moment";
import { required, minLength, requiredIf } from "vuelidate/lib/validators";

export default {
  props: ["formLoan"],
  data() {
    return {
      readonly: true,
      req_loan_amt: false,
      period: [],
      term: [],

      matrix: {
        max: null,
        period: null,
        term: null,
        start: null,
        mode: null,
        charges: [],
      },
    };
  },
  validations: {
    formLoan: {
      req_loan_amt: {
        required,
      },
      req_loan_term: {
        required,
      },
      grace_period: {
        required: requiredIf(function () {
          return this.formLoan.track==3 || this.formLoan.track==4;
        }),
      },
    },
  },
  created() {
    this.evalMaxLoan();
  },
  mounted() {},
  methods: {
    getAggreateAmount() {},
    evalMaxLoan() {
      this.period = [];
      this.term = [];

      let period3 = [3, 6, 9, 12];
      let term3 = [12, 24, 36];
      let period4 = [3, 6, 9, 12, 15, 18, 21, 24];
      let term4 = [12, 24, 36, 48, 60];
      let term12 = [12, 24, 36];

      let track = this.formLoan.track * 1;
      let max = null;
      let damage = (this.formLoan.odette_damage * 1) / 2;


      if (track == 1) {
        this.formLoan.service_fee = "6.0%";
        this.term = term12;

        this.matrix = {
          max: "50% of the previously approved loan amount or 100% of already fully paid loan prior to 17 December 2021 or the requested loan amount, or Php 300.0 thousand, whichever is lowest. The aggregate loan amount should not exceed Php300.0 thousand.",
          period: "N/A",
          term: "max. 3 years",
          start: "After maturity of existing loan",
          mode: "Monthly",
          charges: ["6% Nominal Interest Rate"],
        };
      }

      if (track == 2) {
        this.formLoan.service_fee = "6.0%";
        this.term = term12;

        this.matrix = {
          max:"50% of the previously approved loan amount or 100% of already fully paid loan prior to 17 December 2021 or the requested loan amount, or Php 800.0 thousand, whichever is lowest. The aggregate loan amount should not exceed Php 5.0M.",
          period: "N/A",
          term: "max. 3 years",
          start: "After maturity of existing loan",
          mode: "Monthly",
          charges: ["6% Nominal Interest Rate"],
        };
      }

      if (track == 3) {
        this.formLoan.service_fee = "6.0%";

        this.period = period3;
        this.term = term3;
        max = 300000;

        this.formLoan.max_loan = Math.max(10000, Math.min(damage, max));

        this.matrix = {
          max: "50% of the value of damaged inventory and/or fixed assets OR the requested loan amount OR PhP300.0 thousand, whichever is the lowest.",
          period: "max. 12 mos",
          term: "max. 3 years",
          start: "Upon release",
          mode: "Monthly",
          charges: ["6% Nominal Interest Rate"],
        };
      }

      if (track == 4) {
        this.period = period4;
        this.term = term4;
        max = 5000000;
        this.formLoan.max_loan = Math.max(10000, Math.min(damage, max));

        this.matrix = {
          max: "50% of value of damaged inventory and/or fixed assets OR the requested loan amount whichever is the lowest. The aggregate loan amount should not exceed Php5.0M.",
          period: "max. 24mos",
          term: "max. 5 years",
          start: "Upon release",
          mode: "Monthly",
          charges: [
            "Up to 12 months - 4.0%",
            "13 to 24 months - 6.0%",
            "25 to 36 months - 7.5%",
            "37 to 48 months - 8.0%",
            "49 to 60 months – 10%",
          ],
        };
      }
    },

    evalReq() {
      let amt = this.formLoan.req_loan_amt;
      let track = this.formLoan.track;
      let term = this.formLoan.req_loan_term;

      if (track == 1 || track == 2) {
        this.formLoan.service_fee = "6.0%";
      }

      if (track == 3) {
        this.formLoan.service_fee = "6.0%";
        this.formLoan.bir = "N";
        if (amt <= 50000) {
          this.formLoan.current_permit = "B";
        } else {
          this.formLoan.current_permit = "M";
        }
      }
      if (track == 4) {
        let fees = {
          12: "4.0%",
          24: "6.0%",
          36: "7.5%",
          48: "8.0%",
          60: "10%",
        };
        this.formLoan.service_fee = fees[term];
        
        if (amt <= 50000) {
          this.formLoan.current_permit = "B";
        } else {
          if(amt > 300000){
            this.formLoan.bir = "Y";
          }else{
            this.formLoan.bir = "N";
          }
          this.formLoan.current_permit = "M";
        }
      }
    },

    next() {
      this.evalReq();

      this.$parent.submitting = false;
      this.$parent.submitting = true;
      this.$v.formLoan.$touch();

      if (this.$v.formLoan.$invalid) {
      } else {
        if (this.formLoan.req_loan_amt >= 150000) {
          Swal.fire({
            icon: "info",
            html:
              '<p class="fs-18 mb-0"><b>ISANG PAALALA:</b></p>' +
              '<p class="fs-16 mx-n2">Kung sakaling ang inyong aplikasyon ay ganap na maaprubahan, kakailanganin magsumite ng Post Dated Cheques (PDCs) kasama ng iba pang mga requirements at naayon na kundisyones bago pa man tuluyang matanggap ang inyong CARES loan.</p>' +
              '<hr><p class="fs-18 mb-0"><b>IMPORTANT NOTICE:</b></p>' +
              '<p class="fs-16 mx-n2">(Should your loan application be approved, you shall be required to provide/issue Post Dated Cheques (PDCs) in addition to all other requirements and conditions prior to loan release.)</p>',
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: "Continue",
            cancelButtonText: "Cancel",
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$emit("next");
            }
          });
        } else {
          this.$emit("next");
        }
        // this.$emit('next');
      }
    },
    thousands_separators(num) {
      if (num) {
        let num_parts = num.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
      }
    },
    checkLoanAmount() {
      let loanAmount = this.formLoan.req_loan_amt * 1;
      let maxLoan = this.formLoan.max_loan * 1;
      let amount = this.thousands_separators(maxLoan);

      if (loanAmount) {
        if (loanAmount < 10000) {
          Swal.fire({
            icon: "info",
            title: "Reminder",
            html: `Minimum Loan: <b>Php 10,000</b>`,
            allowOutsideClick: false,
          }).then((response) => {
            this.formLoan.req_loan_amt = null;
            this.formLoan.req_loan_term = null;
            this.formLoan.grace_period = null;
            // this.formLoan.service_fee = null;
            this.formLoan.install_fee = null;
          });
        } else {
          if (loanAmount > maxLoan) {
            Swal.fire({
              icon: "info",
              title: "Reminder",
              html: `Maximum Loan: <b>Php ${amount}</b>`,
              allowOutsideClick: false,
            }).then((response) => {
              this.formLoan.req_loan_amt = null;
              this.formLoan.req_loan_term = null;
              this.formLoan.grace_period = null;
              // this.formLoan.service_fee = null;
              this.formLoan.install_fee = null;
            });
          }
        }
      } else {
        this.formLoan.req_loan_term = null;
        this.formLoan.grace_period = null;
        // this.formLoan.service_fee = null;
        this.formLoan.install_fee = null;
      }
    },
    installFee() {
      if (this.formLoan.grace_period) {
        let term = this.formLoan.req_loan_term * 1;
        let grace = this.formLoan.grace_period * 1;
        this.formLoan.install_fee = term - grace;
      }
    },
    maxNum(e) {
      let val = e.target.value;
      if (e.keyCode === 46) {
        //dot
        e.preventDefault();
      } else {
        if (val.length <= 6) {
          this.formLoan.req_loan_term = null;
          this.formLoan.grace_period = null;
          // this.formLoan.service_fee = null;
          this.formLoan.install_fee = null;
          return true;
        } else e.preventDefault();
      }
    },
    handler($event) {
      if (this.readonly) {
        $event.preventDefault();
      }
    },
  },
  computed: {
    service_fee() {
      let loan = this.formLoan.req_loan_amt * 1;
      let track = this.formLoan.track * 1;

      let max = this.formLoan.max_loan;
      let fee = null;
      let term = this.formLoan.req_loan_term;
      let result = null;

      if (track == 1) {
        fee = 0.06;
        if (loan) {
          result = Math.max(10000, loan) * fee;
        }
      }

      if (track == 2) {
        fee = 0.06;
        if (loan) {
          result = Math.max(10000, loan) * fee;
        }
      }

      if (track == 3) {
        fee = 0.06;
        if (loan) {
          result = Math.max(10000, loan) * fee;
        }
      }
      if (track == 4) {
        // let term4 = [12, 24, 36, 48, 60];
        // let fee4 = [0.04, 0.06, 0.075, 0.08, 0.1];
        // let i = term4.indexOf(term);
        let fees = {
          12: 0.04,
          24: 0.06,
          36: 0.075,
          48: 0.08,
          60: 0.1,
        };
        if (loan && term) {
          // result = Math.max(10000, loan) * fee4[i];
          result = Math.max(10000, loan) * fees[term];
        }
      }
      return result;
    },
  },
};
</script>



<style scoped>
label {
  font-weight: 400 !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>